// Validador para el campo Vatin que es NIF/CIF, ambos deben ser válidos
// En el caso de España tanto 47690794V como V47689889 deben ser válidos

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { CifValidators } from './validators-cif';
import { NifValidators } from './validators-nif';

export class VatinValidators {
    public static createValidator(countryCode: string, companyDif: boolean, isCompany: boolean = false): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (countryCode == null || !control.value) {
                return;
            }
            const nifValidator = NifValidators.validators[countryCode];
            const cifValidator = CifValidators.validators[countryCode];

            const input = control.value?.toString();

            const result = nifValidator?.regExp.exec(input);
            const result2 = cifValidator?.regExp.exec(input);
            if (
                companyDif && result && nifValidator.parse(result).isValid() && !isCompany
                || companyDif && result2 && cifValidator?.parse(result2).isValid() && isCompany
                || !companyDif && result && nifValidator.parse(result).isValid()
                || !companyDif && result2 && cifValidator?.parse(result2).isValid()
            ) {
                return;
            }
            return { pattern: true };
        };
    }
}
